/**
 * TanStack Query hooks for `invalid-device-id-filtering`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	invalidDeviceIdFilteringQueryKeys,
	type CreateInvalidDeviceIdFilteringBody,
	type ListInvalidDeviceIdFilteringResponse,
	type InvalidDeviceIdFilteringRow,
} from "./api";

export function useInvalidDeviceIdFilteringList(): UseQueryResult<ListInvalidDeviceIdFilteringResponse, Error> {
	return useQuery({
		queryKey: invalidDeviceIdFilteringQueryKeys.list(),
		queryFn: list,
	});
}

export function useInvalidDeviceIdFilteringCreate(): UseMutationResult<InvalidDeviceIdFilteringRow, Error, CreateInvalidDeviceIdFilteringBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: invalidDeviceIdFilteringQueryKeys.all });
		},
	});
}

export function useInvalidDeviceIdFilteringDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: invalidDeviceIdFilteringQueryKeys.all });
		},
	});
}
